export default "__VITE_ASSET__DD33Fu0E__"